import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
import { commandLinePackagingInstruction } from "../../Instructions";
import { CommonCommandLineTextForOctopusCliCodeSample, CommonTextForOctopusCli } from "../CommonRegistrationText";
const CommandLinePackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging other applications from command line, we recommend using the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>
            .
        </p>
        {CommonTextForOctopusCli}
        {CommonCommandLineTextForOctopusCliCodeSample}
    </div>);
CommandLinePackaging.displayName = "CommandLinePackaging"
export default commandLinePackagingInstruction(() => <CommandLinePackaging />);
